import React from "react";

const Coffee = ({ fill, svgIconSize, padding, margin }) => {
    const styles = {
        fill: 'none',
        stroke: fill,
        strokeWidth: 20,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 10,
        strokeDasharray: 'none',
        strokeOpacity: 1
    };

    return (
        <svg
            version="1.1"
            id="svg306"

            width={svgIconSize}
            height={svgIconSize}
            viewBox="0 0 682.66669 682.66669"
        >
            <defs id="defs310">
                <clipPath clipPathUnits="userSpaceOnUse" id="clipPath320">
                    <path d="M 0,512 H 512 V 0 H 0 Z" id="path318" />
                </clipPath>
            </defs>
            <g
                id="g312"
                transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
            >
                <g id="g314">
                    <g id="g316" clipPath="url(#clipPath320)">
                        <g id="g322" transform="translate(403.2633,216.0837)">
                            <path
                                d="m 0,0 h 24.737 c 16.542,0 30,13.458 30,30 0,16.542 -13.458,30 -30,30 H 4.441"
                                style={styles}
                                id="path324"
                            />
                        </g>
                        <g id="g326" transform="translate(387.0439,320.0837)">
                            <path
                                d="m 0,0 h 40.956 c 40.804,0 74,-33.196 74,-74 0,-40.804 -33.196,-74 -74,-74 H 1.978"
                                style={styles}
                                id="path328"
                            />
                        </g>
                        <g id="g330" transform="translate(10,98)">
                            <path
                                d="m 0,0 v 0 c 0,-26.51 21.49,-48 48,-48 h 40 c 0,-22.091 17.909,-40 40,-40 h 191.999 c 22.092,0 40,17.909 40,40 h 40 c 26.51,0 48,21.49 48,48 v 0 z"
                                style={styles}
                                id="path332"
                            />
                        </g>
                        <g id="g334" transform="translate(314.6686,365)">
                            <path
                                d="m 0,0 c 13.781,13.781 13.781,36.125 0,49.907 v 0 c -13.781,13.781 -13.781,36.125 0,49.906"
                                style={styles}
                                id="path336"
                            />
                        </g>
                        <g id="g338" transform="translate(153.3308,365)">
                            <path
                                d="m 0,0 c 13.781,13.781 13.781,36.125 0,49.907 v 0 c -13.781,13.781 -13.781,36.125 0,49.906"
                                style={styles}
                                id="path340"
                            />
                        </g>
                        <g id="g342" transform="translate(233.9996,365)">
                            <path
                                d="M 0,0 C 18.916,18.916 18.916,49.584 0,68.5 -18.916,87.416 -18.916,118.084 0,137"
                                style={styles}
                                id="path344"
                            />
                        </g>
                        <g id="g346" transform="translate(130.7893,115.9252)">
                            <path
                                d="M 0,0 C 20.616,20.616 23.937,50.718 7.42,67.236 -9.098,83.754 -39.201,80.432 -59.816,59.816 -80.432,39.201 -83.754,9.098 -67.236,-7.42 -50.718,-23.937 -20.616,-20.616 0,0 Z"
                                style={styles}
                                id="path348"
                            />
                        </g>
                        <g id="g350" transform="translate(74.9533,101.7013)">
                            <path
                                d="m 0,0 c -5.027,19.346 6.581,39.105 25.928,44.132 19.346,5.027 30.955,24.786 25.928,44.132"
                                style={styles}
                                id="path352"
                            />
                        </g>
                        <g id="g354" transform="translate(278.9995,320.0837)">
                            <path
                                d="m 0,0 h 128.705 v -60.678 c 0,-62.213 -27.126,-121.045 -73.789,-161.406"
                                style={styles}
                                id="path356"
                            />
                        </g>
                        <g id="g358" transform="translate(75.6971,179.7989)">
                            <path
                                d="m 0,0 c -10.046,24.985 -15.402,51.962 -15.402,79.607 v 60.678 h 128.705"
                                style={styles}
                                id="path360"
                            />
                        </g>
                        <g id="g362" transform="translate(233.9996,320.0837)">
                            <path
                                d="M 0,0 V 0"
                                style={styles}
                                id="path364"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Coffee;
